import { Box, Typography, Container, Paper } from "@mui/material";

export function TermsOfUse() {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: { xs: 2, md: 4 } }}>
        <Typography variant="h5" component="h1" gutterBottom fontWeight={600} color="#133859">
          Termos de Uso – Sagrada Visão
        </Typography>

        <Typography variant="body2" color="text.secondary" gutterBottom>
          Última atualização: 10/01/2026
        </Typography>

        <Box mt={2}>
          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            1. Quem somos
          </Typography>
          <Typography variant="body2" paragraph>
            O Sagrada Visão é um aplicativo que ajuda você a se conectar com médicos oftalmologistas parceiros,
            facilitando o agendamento e o acompanhamento de consultas.
          </Typography>

          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            2. Aceitação dos termos
          </Typography>
          <Typography variant="body2" paragraph>
            Ao se cadastrar, acessar ou usar o Sagrada Visão, você declara que leu e concorda com estes Termos de Uso
            e que tem pelo menos 18 anos ou é representado por um responsável legal. Se você não concordar com estes
            termos, não deve utilizar a aplicação.
          </Typography>

          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            3. Cadastro e conta
          </Typography>
          <Typography variant="body2" paragraph>
            Para usar o Sagrada Visão, você precisa criar uma conta, informando dados verdadeiros e atualizados. Você se
            compromete a não compartilhar sua senha e códigos de confirmação com outras pessoas, a manter seus dados de
            contato atualizados e a ser responsável por todas as ações feitas na sua conta. Em caso de uso indevido,
            entre em contato conosco pelos canais oficiais do Sagrada Visão.
          </Typography>

          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            4. Uso do Sagrada Visão
          </Typography>
          <Typography variant="body2" paragraph>
            Pelo aplicativo, você pode visualizar médicos oftalmologistas parceiros e seus horários disponíveis,
            agendar consultas e acompanhar seus agendamentos. Os atendimentos médicos são prestados exclusivamente pelos
            médicos parceiros, que são os únicos responsáveis pelas orientações, diagnósticos e tratamentos realizados.
          </Typography>

          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            5. Consultas, remarcações e faltas
          </Typography>
          <Typography variant="body2" paragraph>
            Cada médico ou clínica pode ter suas próprias regras de agendamento, remarcação, cancelamento e cobrança
            por faltas. Sempre que possível, avise com antecedência se não puder comparecer a uma consulta. O Sagrada
            Visão não é responsável por valores cobrados diretamente pelos médicos, clínicas ou convênios.
          </Typography>

          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            6. Privacidade e proteção de dados
          </Typography>
          <Typography variant="body2" paragraph>
            O Sagrada Visão se preocupa com a proteção dos seus dados pessoais. Suas informações serão tratadas de
            acordo com a legislação aplicável e com a nossa Política de Privacidade, que detalha como coletamos, usamos
            e protegemos seus dados. Alguns dados são necessários para identificar você, realizar agendamentos e
            permitir que o médico parceiro tenha as informações mínimas para atendê-lo adequadamente.
          </Typography>

          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            7. Uso adequado do aplicativo
          </Typography>
          <Typography variant="body2" paragraph>
            Você se compromete a não usar o Sagrada Visão para fins ilegais, ofensivos ou discriminatórios, a não tentar
            invadir ou prejudicar o funcionamento do aplicativo e a não criar cadastros falsos ou usar dados de
            terceiros sem autorização. O Sagrada Visão pode suspender ou encerrar o acesso de usuários que descumprirem
            estes termos ou que causem riscos à segurança da plataforma ou de outras pessoas.
          </Typography>

          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            8. Responsabilidades
          </Typography>
          <Typography variant="body2" paragraph>
            O Sagrada Visão se responsabiliza por disponibilizar o aplicativo de forma razoavelmente segura e estável,
            corrigir problemas técnicos relevantes e adotar medidas de segurança para proteger seus dados. O Sagrada
            Visão não é responsável por decisões médicas, diagnósticos, tratamentos ou condutas adotadas pelos médicos
            parceiros, nem por resultados de exames, procedimentos ou tratamentos oftalmológicos, ou por atrasos e
            cancelamentos de consultas feitos pelos médicos ou clínicas.
          </Typography>

          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            9. Comunicações
          </Typography>
          <Typography variant="body2" paragraph>
            Podemos enviar avisos e lembretes relacionados às suas consultas e à sua conta por e-mail, SMS,
            notificações no aplicativo ou outros meios informados por você. Ao usar o Sagrada Visão, você autoriza o
            envio dessas comunicações relacionadas ao uso do serviço.
          </Typography>

          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            10. Alterações destes Termos
          </Typography>
          <Typography variant="body2" paragraph>
            Estes Termos de Uso podem ser atualizados de tempos em tempos. Quando houver mudanças importantes, poderemos
            avisar você pelo aplicativo ou pelos seus dados de contato. Continuar usando o Sagrada Visão após a
            atualização significa que você concorda com a nova versão dos termos.
          </Typography>

          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            11. Disposições finais
          </Typography>
          <Typography variant="body2" paragraph>
            Estes Termos de Uso são regidos pelas leis da República Federativa do Brasil. Caso alguma disposição seja
            considerada inválida, as demais continuarão válidas. Em caso de dúvidas, entre em contato pelos canais
            oficiais do Sagrada Visão.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}
